import React, { type ReactNode } from 'react';
import styled from 'types/theme.types';
import { ReactComponent as env0Logo } from 'assets/images/logo-white.svg';
import { Helmet } from 'react-helmet';
import logo3d from 'assets/images/logo-3d.png';
export const OnboardingLayout: React.FC<{ children?: ReactNode }> = ({ children }) => {
  return (
    <>
      <Helmet>
        <title>env0 - Onboarding</title>
      </Helmet>
      <OuterContainer>
        <MainLayoutContainer>
          <BackgroundLogo src={logo3d} />
          <Env0Logo />
          <WhiteContainer>{children}</WhiteContainer>
        </MainLayoutContainer>
      </OuterContainer>
    </>
  );
};

const BackgroundLogo = styled.img`
  position: absolute;
  right: 5%;
  bottom: 0;
  width: 50%;
  height: 100%;
  z-index: 0;
  rotate: 5deg;
  @media (max-width: 768px) {
    width: 100%;
    height: 50%;
  }
`;

const OuterContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
`;

const MainLayoutContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  background: ${({ theme }) => theme.secondaryBlack};
  background-size: cover;
`;

const Env0Logo = styled(env0Logo)`
  margin: 50px;
  transform: scale(1.3);
  flex: none;
`;

const cardWidth = '970px' as const;
const WhiteContainer = styled.div`
  display: flex;
  overflow: auto;
  width: ${cardWidth};
  height: 80%;
  min-height: 750px;
  border-radius: 4px;
  background: ${({ theme }) => theme.primaryWhite};
  position: relative;
  z-index: 1;

  @media (max-width: ${cardWidth}) {
    width: 100%;
    height: min-content;
    border-radius: 0;
    flex: 1;
  }
`;

export default OnboardingLayout;
